import React from 'react'

const Selector = ({ customer_types, addTag }) => {
  return (
    <div
      id="dropdown"
      className="w-3/12 absolute shadow top-100 bg-white z-40 max-h-select overflow-y-auto"
    >
      <div className="flex flex-col">
        {customer_types.map((item, key) => {
          return (
            <div
              key={key}
              className="cursor-pointer w-full border-gray-100 hover:bg-light-gray hover:dark:bg-slate-700 dark:bg-slate-800"
              onClick={() => addTag(item)}
            >
              <div className="flex w-full items-center p-2 pl-2 border-transparent relative hover:border-teal-100">
                <div className="w-full items-center flex">
                  <div className="mx-2 leading-6 dark:text-gray-200">{item?.value}</div>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default React.memo(Selector)
